import React from 'react';
import { Icon } from './Icon.js';
export const IconCaretMaximizeDiagonal = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M19 11.976L18.0372 11.9759L12 6L12 5L19 5L19 11.976Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M5 12.024L5.96276 12.0241L12 18L12 19L5 19L5 12.024Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconCaretMaximizeDiagonal.js.map